function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              * RegisterAfterQuizController controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              * @namespace gplans.authentication.controllers
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              */
(function () {
  'use strict';RegisterAfterQuizController.$inject = ["$state", "$uibModal", "$rootScope", "$http", "$q", "$analytics", "Authentication", "User", "$localStorage", "$window", "Profile", "Snackbar", "mesSystem", "MeasurementSystem", "TempCheckin", "UserService"];

  angular.
  module('gplans.authentication.controllers').
  controller('EmailTakenModalInstanceCtrl', ["$uibModalInstance", "$state", "$localStorage", "Authentication", "email", function ($uibModalInstance, $state, $localStorage, Authentication, email) {
    var vm = this;
    vm.cancel = cancel;
    vm.resetQuiz = resetQuiz;
    vm.sendLink = sendLink;

    function resetQuiz() {
      Authentication.resetAccount();

      $uibModalInstance.close('resetQuiz');
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function sendLink() {
      Authentication.sendQuizCompleteLink(email).then(function () {
        alert("Link sent, please check your mail!");
      }, function () {
        alert("An error occured when we tried to send your link :(");
      });
      $uibModalInstance.close('linkSent');
    }
  }]).
  controller('RegisterAfterQuizController', RegisterAfterQuizController);

  RegisterAfterQuizController.$inject = ['$state', '$uibModal', '$rootScope', '$http', '$q', '$analytics', 'Authentication', 'User', '$localStorage',
  '$window', 'Profile', 'Snackbar', 'mesSystem', 'MeasurementSystem', 'TempCheckin', 'UserService'];

  /**
                                                                                                     * @namespace RegisterAfterQuizController
                                                                                                     */
  function RegisterAfterQuizController($state, $uibModal, $rootScope, $http, $q, $analytics, Authentication, User, $localStorage, $window, Profile,
  Snackbar, mesSystem, MeasurementSystem, TempCheckin, UserService) {
    var vm = this;
    var modalInstance;

    activate();

    /**
                 * @name activate
                 * @desc Actions to be performed when this controller is instantiated
                 * @memberOf gplans.authentication.controllers.RegisterAfterQuizController
                 */
    function activate() {
      var cbBadge = document.getElementById('cbBadge');
      if (cbBadge) {
        cbBadge.remove();
        delete $rootScope.clickbankBadgeInstalled;
      }
      $rootScope.loginPage = $state.current.loginPage;
      vm.user = User;

      if (vm.user && !vm.user.last_checkin) {
        createCheckin();
      }

      if ($localStorage.userSurvey) {
        // TODO should be fetchUserSurvey, but w/o applying user information
        $http.get(gplansConf.API_URL + '/api/v1/usersurveys/' + $localStorage.userSurvey + '/').then(function (data) {
          vm.usersurvey = data.data;

          $http.get(gplansConf.API_URL + '/api/v1/metabolictypes/' + vm.usersurvey.metabolic_type + '/').then(function (response) {
            vm.metabolic_type = response.data;
          });
        });
      }

      vm.rounded_age = window.gplansStorage.age ? Number(window.gplansStorage.age) - Number(window.gplansStorage.age) % 10 : 30;
      vm.gender = window.gplansStorage.gender ? window.gplansStorage.gender : 'male';
      $analytics.eventTrack('Email After Quiz Page');
    }

    vm.register = register;
    vm.fbConnect = fbConnect;
    vm.seeResults = seeResults;
    vm.resetAccount = resetAccount;

    /**
                                    * @name register
                                    * @desc Register a new user
                                    * @memberOf gplans.authentication.controllers.RegisterAfterQuizController
                                    */
    function register() {
      var user;
      Authentication.createAccount({
        'email': vm.email,
        'user_survey_pk': $localStorage['userSurvey'],
        'blood_test': $localStorage['bloodTest'] },
      'base.complete', {
        userSurvey: $localStorage['userSurvey'] }).

      then(function (res) {
        if (window.fbq) fbq('track', 'Lead');

        // LI conversion TODO: refactor along with
        window.liQ = window.liQ || [];
        window.liQ.push(
        {
          "event": "conversion", //required
          "email": res.user.uid // we send uid instead of email for privacy reasons
        });


        user = res.user;
        user.gender = $window.gplansStorage.gender;
        user.age = $window.gplansStorage.age;
        if (mesSystem == 'SI') {
          user.goal_weight = Math.round(MeasurementSystem.convertKgToLbs($window.gplansStorage.goal_weight));
          user.current_weight = Math.round(MeasurementSystem.convertKgToLbs($window.gplansStorage.current_weight));
          user.height = Math.round(MeasurementSystem.convertCmToInch($window.gplansStorage.height));
        } else
        {
          user.height = $window.gplansStorage.height;
          user.goal_weight = $window.gplansStorage.goal_weight;
          user.current_weight = $window.gplansStorage.current_weight;
        }
        if ($rootScope.offerId != 'straightSale') {
          user.first_name = vm.firstName;
          user.last_name = vm.lastName;
        }
        // show results before update is completed
        if (user.id) {
          UserService.set(_objectSpread({},
          user, {
            first_name: user.first_name,
            last_name: user.last_name,
            gender: user.gender,
            age: user.age,
            current_weight: parseFloat(user.current_weight),
            goal_weight: parseFloat(user.goal_weight),
            height: parseFloat(user.height) }));

        }

        return 'processed';
      }, function (err) {
        if (err.data.email) {
          try {
            vm.errorEmail = err.data.email + '';
          } catch (e) {
            console.warn('error', e);
          }
        } else
        showPopup();
        console.log(err);
      }).
      then(createCheckin).
      then(function () {
        if (user)
        return Profile.update(user).then(profileSuccessFn, profileErrorFn);

        function profileSuccessFn(res, status, headers, config) {
          Authentication.setAuthenticatedAccount(res.data);

          if (UserService.data.id) {
            UserService.set(_objectSpread({},
            UserService.data, {
              first_name: res.data.first_name,
              last_name: res.data.last_name,
              gender: res.data.gender,
              age: parseInt(res.data.age),
              current_weight: parseFloat(res.data.current_weight),
              goal_weight: parseFloat(res.data.goal_weight),
              height: parseFloat(res.data.height) }));

          }

          var weightGoalDirection;
          if (UserService.data.goal_weight > UserService.data.current_weight + 6) {
            weightGoalDirection = 'gain';
          } else
          if (UserService.data.goal_weight < UserService.data.current_weight - 6) {
            weightGoalDirection = 'lose';
          } else
          {
            weightGoalDirection = 'maintain';
          }
          var oMisc = { 'key': 'weightGoalDirection', 'value': weightGoalDirection };

          Profile.createMisc(oMisc);
        }

        function profileErrorFn(data, status, headers, config) {
          console.log(data);
          return $q.reject(data);
        }
      });
    }

    function createCheckin() {
      if ($localStorage.bloodTypeResult && $localStorage.bloodTypeResult.id) {
        var oCheckin = {
          metabolic_type: $localStorage.bloodTypeResult.id,
          weight: UserService.data.current_weight,
          week_number: 1 };


        return TempCheckin.createCheckin(oCheckin);
      } else if (UserService.data.id) {
        return fetchUserSurvey().
        then(function (oCheckin) {
          return TempCheckin.createCheckin(oCheckin);
        });
      }
    }

    function fetchUserSurvey() {
      return $http.get(gplansConf.API_URL + '/api/v1/usersurveys/' + $localStorage.userSurvey + '/').
      then(function (data) {
        vm.usersurvey = data.data;
        vm.metabolic_type = vm.usersurvey.metabolic_type;
        var oCheckin = {
          metabolic_type: vm.usersurvey.metabolic_type,
          weight: UserService.data.current_weight,
          week_number: 1 };

        return oCheckin;
      });
    }

    function seeResults() {
      $state.go('base.complete', { userSurvey: $localStorage.userSurvey });
    }

    function resetAccount() {
      console.log('account reset');
      Authentication.resetAccount();
    }

    function showPopup(_email) {
      modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'templates/authentication/email-taken.modal.html',
        controller: 'EmailTakenModalInstanceCtrl',
        controllerAs: 'vm',
        resolve: {
          email: function email() {
            return vm.email ? vm.email : _email;
          } } });


      modalInstance.result.then(function (res) {
        console.log(res);
      }, function () {
        console.log('Cancelled');
      });

      return $q.reject();
    }

    /**
       * @name fbConnect
       * @desc Connect the logged in user to facebook
       * @memberOf gplans.layout.controllers.RegisterAfterQuizController
       */
    function fbConnect() {
      FB.login(function (res) {
        if (res.status === 'connected') {
          Authentication.facebookRegister(res.authResponse.accessToken, $localStorage['userSurvey']).
          then(function (res) {
            console.log(res);
            res.user.gender = $window.gplansStorage.gender;
            res.user.age = $window.gplansStorage.age;
            res.user.current_weight = $window.gplansStorage.current_weight;
            res.user.goal_weight = $window.gplansStorage.goal_weight;
            res.user.height = $window.gplansStorage.height;
            Profile.update(res.user).then(profileSuccessFn, profileErrorFn);

            /**
                                                                              * @name profileSuccessFn
                                                                              * @desc Show success snackbar
                                                                              */
            function profileSuccessFn(data, status, headers, config) {
              console.log(data);
              createCheckin().then(function () {
                Authentication.check().then(function (res) {
                  $state.go('base.complete', { userSurvey: $localStorage['userSurvey'] });
                });
              });
              //Snackbar.show('Your profile has been updated.');
            }


            /**
               * @name profileErrorFn
               * @desc Show error snackbar
               */
            function profileErrorFn(data, status, headers, config) {
              Snackbar.error(data.error);
            }
          }, function (err) {
            if (err.data.email)
            showPopup(err.data.email);else

            alert('Something wrong with your data');
          });
        }
      }, { scope: 'email' });
    }
  }
})();